import { Bar } from 'vue-chartjs';

export default {
    extends: Bar,
    name: 'TimeBarChart',
    
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        }
    },
    mounted () {
        // console.log('TBC: mounted')
        this.renderChart (this.chartdata, this.options)
    }
}
